import { render } from "./InventoryManagement.vue?vue&type=template&id=4d201ad8&scoped=true"
import script from "./InventoryManagement.vue?vue&type=script&lang=js"
export * from "./InventoryManagement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4d201ad8"

export default script